import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {computed} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {HighlightsTabModel} from "../highlights.tab-model";
import {CompetitorHighlightsPageLinkModel} from "../../../../../containers/competitor-container/pages/highlights-page/models/competitor.highlights-page.link-model";
import {NEW_COMPETITOR_CONTAINER} from "../../../../../containers/competitor-container/competitor-container.consts";
import type {CompetitorViewModel} from "../../../../../domain/common/competitor/models/competitor-view-model";

export class CompetitorHighlightsPageTabModel extends HighlightsTabModel {
  index: Number;
  name: String;
  entity: CompetitorViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: CompetitorViewModel,
    currentLinkModel: BaseLinkModel
  ) {
    super(index, name)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  @computed get linkModel(): CompetitorHighlightsPageLinkModel {
    const linkModel: CompetitorHighlightsPageLinkModel = new CompetitorHighlightsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === NEW_COMPETITOR_CONTAINER.FILTERS.highlights;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competitor;
  }
  get elementId(): String {
    return 'navigation-tabs_competitor_highlights';
  }
}
